import PropTypes from "prop-types";
import RCSwitch from "rc-switch";

/**
 * Toggle switch component wrapping rc-switch with On/Off labels.
 *
 * @param root0 - The component props.
 * @param root0.checkedChildren - The label when the switch is on.
 * @param root0.unCheckedChildren - The label when the switch is off.
 * @returns The rendered switch component.
 */
const Switch = ({
    checkedChildren = "On",
    unCheckedChildren = "Off",
    ...props
}) => {
    const handleClick = (e) => {
        // Prevent click from bubbling up to parent dropdown menus
        e.stopPropagation();
    };

    return (
        <span className="lights-map-switch" onClick={handleClick}>
            <RCSwitch
                checkedChildren={checkedChildren}
                unCheckedChildren={unCheckedChildren}
                {...props}
            />
        </span>
    );
};

Switch.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool,
    checkedChildren: PropTypes.string,
    unCheckedChildren: PropTypes.string,
};

export default Switch;
